/* BeadznThreadz — collection & search grid enhancements on top of Dawn's facets.js
   - grid density toggle (remembered)
   - quick size pills / facet links through Dawn's AJAX renderer
   - search box inside long filter lists
   - load more / infinite scroll with progress */
(function () {
  if (window.BZCollection) return;

  const STORE_KEY = 'bz:grid-cols';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const readCols = () => {
    try {
      return JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  };
  const writeCols = (v) => {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify(v));
    } catch (e) {}
  };

  function roots() {
    return document.querySelectorAll('[data-bz-collection]');
  }

  /* ---------- Density ---------- */
  function applyDensity(root) {
    // Saved choice only applies where the toggle is offered; otherwise use section defaults
    const saved = root.querySelector('[data-bz-cols]') ? readCols() : {};
    const d = saved.d || root.dataset.defaultColsD;
    const m = saved.m || root.dataset.defaultColsM;
    root.dataset.colsD = d;
    root.dataset.colsM = m;
    root.querySelectorAll('[data-bz-cols]').forEach((btn) => {
      const val = btn.dataset.bzCols;
      const on = btn.dataset.bzColsScope === 'd' ? val === String(d) : val === String(m);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-bz-cols]');
    if (!btn) return;
    const root = btn.closest('[data-bz-collection]');
    if (!root) return;
    const saved = readCols();
    saved[btn.dataset.bzColsScope] = btn.dataset.bzCols;
    writeCols(saved);
    roots().forEach(applyDensity);
  });

  /* ---------- Bar-mode renderer (Section Rendering API, no dependency on facets.js) ---------- */
  let renderController;
  function barRoot() {
    return document.querySelector('[data-bz-collection][data-filter-mode="bar"]');
  }

  function scrollToGrid() {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    const top = grid.getBoundingClientRect().top + window.scrollY - offset - 24;
    if (window.scrollY > top) window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function render(query, push) {
    const root = barRoot();
    const container = document.getElementById('ProductGridContainer');
    if (!root || !container) return;
    if (renderController) renderController.abort();
    renderController = 'AbortController' in window ? new AbortController() : null;
    container.classList.add('is-loading');
    document.querySelectorAll('[data-bz-swap]').forEach((el) => el.classList.add('is-loading'));
    const url = `${window.location.pathname}?section_id=${root.dataset.sectionId}${query ? '&' + query : ''}`;
    fetch(url, renderController ? { signal: renderController.signal } : {})
      .then((r) => r.text())
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
        if (!fresh) throw new Error('missing grid');
        document.querySelectorAll('.bz-fsheet[open]').forEach((d) => window.BZ && window.BZ.closeDrawer(d));
        document.documentElement.classList.remove('bz-lock');
        const doc = fresh.ownerDocument;
        const active = document.activeElement && document.activeElement.id;
        document.querySelectorAll('[data-bz-swap][id]').forEach((el) => {
          const next = doc.getElementById(el.id);
          if (!next) return;
          const open = [...el.querySelectorAll('details[id]')].reduce((m, d) => ((m[d.id] = d.open), m), {});
          const scroll = el.scrollTop;
          el.innerHTML = next.innerHTML;
          el.querySelectorAll('details[id]').forEach((d) => {
            if (d.id in open) d.open = open[d.id];
          });
          el.scrollTop = scroll;
        });
        container.innerHTML = fresh.innerHTML;
        container.classList.remove('is-loading');
        document.querySelectorAll('[data-bz-swap]').forEach((el) => el.classList.remove('is-loading'));
        if (active) {
          const again = document.getElementById(active);
          if (again && again.focus) again.focus({ preventScroll: true });
        }
        if (push !== false) history.pushState({ bzQuery: query }, '', `${window.location.pathname}${query ? '?' + query : ''}`);
        initRoot(root);
        if (window.BZ) window.BZ.init(container);
        scrollToGrid();
      })
      .catch((err) => {
        if (err && err.name === 'AbortError') return;
        window.location.href = `${window.location.pathname}${query ? '?' + query : ''}`;
      });
  }

  window.addEventListener('popstate', () => {
    if (barRoot()) render(window.location.search.slice(1), false);
  });

  function formQuery(form) {
    const params = new URLSearchParams();
    // Mobile sheet is self-contained; desktop merges every filter form on the page (bar or sidebar)
    const forms = form && form.hasAttribute('data-bz-mobile')
      ? [form]
      : [...document.querySelectorAll('[data-bz-filter-form]:not([data-bz-mobile])')];
    if (form && !forms.includes(form)) forms.push(form);
    forms.forEach((f) =>
      new FormData(f).forEach((value, key) => {
        if (value === '' || value === null) return;
        if (params.getAll(key).includes(value)) return;
        params.append(key, value);
      })
    );
    // Keep the sort choice from the desktop bar when submitting a popover
    if (!params.has('sort_by')) {
      const sort = document.querySelector('[data-bz-sort]');
      if (sort && sort.value) params.set('sort_by', sort.value);
    }
    return params.toString();
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-bz-filter-form]');
    if (!form) return;
    e.preventDefault();
    render(formQuery(form));
  });

  document.addEventListener('change', (e) => {
    const sort = e.target.closest('[data-bz-sort]');
    if (sort) {
      render(formQuery(sort.form));
      return;
    }
    const instant = e.target.closest('[data-bz-filter-form][data-bz-instant]');
    if (instant && (e.target.name || e.target.hasAttribute('data-bz-range'))) {
      clearTimeout(instantTimer);
      instantTimer = setTimeout(() => render(formQuery(instant)), 250);
    }
  });
  let instantTimer;

  /* Popovers: one open at a time, close on outside click / Escape */
  document.addEventListener('toggle', (e) => {
    const el = e.target;
    if (!el.matches || !el.matches('[data-bz-fpop]') || !el.open) return;
    document.querySelectorAll('[data-bz-fpop][open]').forEach((d) => d !== el && d.removeAttribute('open'));
    const panel = el.querySelector('.bz-fpop__panel');
    if (panel) {
      panel.classList.remove('is-right');
      const r = panel.getBoundingClientRect();
      if (r.right > window.innerWidth - 16) panel.classList.add('is-right');
    }
  }, true);
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-bz-fpop]')) return;
    document.querySelectorAll('[data-bz-fpop][open]').forEach((d) => d.removeAttribute('open'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = document.querySelector('[data-bz-fpop][open]');
    if (!open) return;
    open.removeAttribute('open');
    const s = open.querySelector('summary');
    if (s) s.focus();
  });

  /* Price slider ↔ number inputs */
  function syncPrice(wrap) {
    const max = parseFloat(wrap.dataset.max) || 0;
    const rMin = wrap.querySelector('[data-bz-range="min"]');
    const rMax = wrap.querySelector('[data-bz-range="max"]');
    const fill = wrap.querySelector('.bz-price__fill');
    if (!rMin || !rMax || !fill || !max) return;
    const a = Math.min(+rMin.value, +rMax.value);
    const b = Math.max(+rMin.value, +rMax.value);
    fill.style.left = `${(a / max) * 100}%`;
    fill.style.right = `${100 - (b / max) * 100}%`;
  }
  document.addEventListener('input', (e) => {
    const wrap = e.target.closest('[data-bz-price]');
    if (!wrap) return;
    const iMin = wrap.querySelector('[data-bz-price-input="min"]');
    const iMax = wrap.querySelector('[data-bz-price-input="max"]');
    const rMin = wrap.querySelector('[data-bz-range="min"]');
    const rMax = wrap.querySelector('[data-bz-range="max"]');
    const max = parseFloat(wrap.dataset.max) || 0;
    if (e.target === rMin || e.target === rMax) {
      if (+rMin.value > +rMax.value) {
        if (e.target === rMin) rMin.value = rMax.value;
        else rMax.value = rMin.value;
      }
      iMin.value = +rMin.value > 0 ? rMin.value : '';
      iMax.value = +rMax.value < max ? rMax.value : '';
    } else if (e.target === iMin || e.target === iMax) {
      rMin.value = iMin.value || 0;
      rMax.value = iMax.value || max;
    }
    syncPrice(wrap);
  });

  /* ---------- Facet links (chips, quick sizes, clear) ---------- */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[data-bz-facet-link]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const href = link.getAttribute('href');
    const query = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);
    if (barRoot()) {
      e.preventDefault();
      link.classList.add('is-loading');
      render(query);
      return;
    }
    if (typeof FacetFiltersForm === 'undefined' || !document.getElementById('product-grid')) return;
    e.preventDefault();
    link.classList.add('is-loading');
    FacetFiltersForm.renderPage(query);
    scrollToGrid();
  });

  /* ---------- Search inside long filter lists ---------- */
  function enhanceFilterLists(root) {
    const threshold = parseInt(root.dataset.filterSearchThreshold, 10) || 8;
    const placeholder = root.dataset.filterSearchPlaceholder || 'Search';
    const lists = document.querySelectorAll(
      '#FacetFiltersForm .facets-wrap, #FacetFiltersFormMobile .mobile-facets__submenu'
    );
    lists.forEach((wrap) => {
      if (wrap.querySelector('.bz-filter-search')) return;
      const items = wrap.querySelectorAll('.facets__item, .mobile-facets__item');
      if (items.length <= threshold) return;
      const field = document.createElement('div');
      field.className = 'bz-filter-search';
      field.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.75" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="m15.5 15.5 5.25 5.25" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
      const input = document.createElement('input');
      input.type = 'search';
      input.placeholder = placeholder;
      input.setAttribute('aria-label', placeholder);
      input.setAttribute('form', 'bz-none'); // keep out of Dawn's FormData
      field.appendChild(input);
      const list = wrap.querySelector('ul');
      if (!list) return;
      list.parentNode.insertBefore(field, list);
      const more = wrap.querySelector('show-more-button');
      input.addEventListener('input', () => {
        const q = input.value.trim().toLowerCase();
        items.forEach((li) => {
          const match = !q || li.textContent.toLowerCase().includes(q);
          li.classList.toggle('bz-filter-hide', !match);
          li.classList.toggle('bz-force-show', !!q && match);
        });
        if (more) more.hidden = !!q;
      });
      // Stop Dawn's debounced "input" submit for this field
      input.addEventListener('input', (ev) => ev.stopPropagation());
    });
  }

  /* ---------- Load more / infinite ---------- */
  let infiniteObserver;
  function bindInfinite(root) {
    if (infiniteObserver) infiniteObserver.disconnect();
    if (root.dataset.pagination !== 'infinite' || !('IntersectionObserver' in window)) return;
    const btn = root.querySelector('[data-bz-load-more]');
    if (!btn) return;
    infiniteObserver = new IntersectionObserver(
      (entries) => {
        if (entries.some((en) => en.isIntersecting)) loadMore(btn);
      },
      { rootMargin: '600px 0px' }
    );
    infiniteObserver.observe(btn);
  }

  function loadMore(btn) {
    if (btn.dataset.loading) return;
    const root = btn.closest('[data-bz-collection]');
    const grid = root && root.querySelector('#product-grid');
    if (!grid) return;
    btn.dataset.loading = 'true';
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    const url = new URL(btn.dataset.nextUrl, window.location.origin);
    url.searchParams.set('section_id', root.dataset.sectionId);
    fetch(url.pathname + url.search)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('#product-grid > li');
        const frag = document.createDocumentFragment();
        newItems.forEach((li, i) => {
          li.style.setProperty('--bz-i', i % 4);
          frag.appendChild(li);
        });
        grid.appendChild(frag);
        const newPaging = doc.querySelector('[data-bz-paging]');
        const paging = root.querySelector('[data-bz-paging]');
        if (paging && newPaging) paging.replaceWith(newPaging);
        if (window.BZ) window.BZ.init(grid);
        bindInfinite(root);
        const firstNew = newItems[0] && newItems[0].querySelector('a');
        if (firstNew && btn.matches(':focus')) firstNew.focus({ preventScroll: true });
      })
      .catch(() => {
        window.location.href = btn.dataset.nextUrl;
      });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-bz-load-more]');
    if (!btn) return;
    e.preventDefault();
    loadMore(btn);
  });

  /* ---------- Auto-sliding rails: <ul class="bz-track" data-bz-autoslide="3"> (seconds) ---------- */
  function autoslide(track) {
    if (track.dataset.bzAutoBound) return;
    track.dataset.bzAutoBound = 'true';
    const delay = Math.max(1.5, parseFloat(track.dataset.bzAutoslide) || 3) * 1000;
    if (reduceMotion || !delay) return;
    let timer = null;
    let paused = false;
    let visible = false;
    const step = () => {
      const item = track.firstElementChild;
      if (!item) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const w = item.getBoundingClientRect().width + gap;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + w, behavior: 'smooth' });
    };
    const run = () => {
      clearInterval(timer);
      timer = null;
      if (!paused && visible && !document.hidden && track.scrollWidth > track.clientWidth + 4) timer = setInterval(step, delay);
    };
    const pause = () => { paused = true; run(); };
    const resume = () => { paused = false; run(); };
    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', resume);
    track.addEventListener('focusin', pause);
    track.addEventListener('focusout', resume);
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', () => setTimeout(resume, 4000), { passive: true });
    document.addEventListener('visibilitychange', run);
    // Arrow clicks restart the countdown
    const wrap = track.parentElement;
    if (wrap) wrap.addEventListener('click', (e) => { if (e.target.closest('[data-bz-prev],[data-bz-next]')) run(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; run(); }, { threshold: 0.2 }).observe(track);
    } else {
      visible = true;
      run();
    }
  }
  function initAutoslide(scope) {
    (scope || document).querySelectorAll('[data-bz-autoslide]').forEach(autoslide);
  }

  /* ---------- Init & re-init after Dawn re-renders ---------- */
  function initRoot(root) {
    root.classList.add('bz-js');
    applyDensity(root);
    if (root.dataset.filterMode !== 'bar') enhanceFilterLists(root);
    bindInfinite(root);
    root.querySelectorAll('[data-bz-price]').forEach(syncPrice);
  }

  function init() {
    initAutoslide();
    roots().forEach((root) => {
      initRoot(root);
      if (root.dataset.bzObserved) return;
      root.dataset.bzObserved = 'true';
      let t;
      new MutationObserver(() => {
        clearTimeout(t);
        t = setTimeout(() => {
          initRoot(root);
          if (window.BZ) window.BZ.init(root);
        }, 30);
      }).observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);

  window.BZCollection = { init, loadMore, render };
})();
